// removed by extract-text-webpack-plugin
module.exports = {"plan-summary":"plan-summary__1VZDR","content":"content__1Ikxy","elss-table":"elss-table__19wTJ","elss-graph":"elss-graph__2g9__","invest-not-allowed":"invest-not-allowed__1VklO"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/planSummary.scss
// module id = 748
// module chunks = 68